import api from "./API";
import {AccountSubmissionTemplate, Payee} from "../Types/Payee";

export async function getMyPayeeAccount(): Promise<Payee | null> {
    try {
        const response = await api.get("/api/account/get/payees/me");
        if (response.status === 204) {
            return null;
        }

        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function getAllPayees(): Promise<Payee[]> {
    try {
        const response = await api.get("/api/account/get/payees");
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function deleteMyPayeeAccount(accountUid: string): Promise<void> {
    try {
        await api.delete(`/api/account/delete/payee/account/me/${accountUid}`);
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function setMyDefaultPayeeAccount(accountUid: string): Promise<void> {
    try {
        await api.put(`/api/account/set/payee/default-account/me/${accountUid}`);
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function addMyPayeeAccount(newAccount: AccountSubmissionTemplate): Promise<void> {
    try {
        await api.put(`/api/account/add/payee/account/me`, newAccount);
    } catch (error) {
        console.error(error);
        throw error;
    }
}